export var HelpPageTabs;
(function (HelpPageTabs) {
    HelpPageTabs["About"] = "About";
    HelpPageTabs["Instructions"] = "Instructions";
    HelpPageTabs["Faq"] = "Faq";
})(HelpPageTabs || (HelpPageTabs = {}));
